import { render, staticRenderFns } from "./kxUnbind.vue?vue&type=template&id=636ee910&"
import script from "./kxUnbind.vue?vue&type=script&lang=js&"
export * from "./kxUnbind.vue?vue&type=script&lang=js&"
import style0 from "./kxUnbind.vue?vue&type=style&index=0&id=636ee910&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports